import { StandardButton } from 'src/components/Reusable/Buttons'
import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'

export const OIDCEmailButton = styled(StandardButton)`
  margin-top: 2px;
  margin-bottom: 24px;
  padding: 1px 16px;
`

export const OIDCEmailText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-grow: 1;
  color: white;
`

export const OIDCEmailPageNewContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  gap: 32px;
  padding: 2rem;
`

export const OIDCEmailNewText = styled.div`
  font-size: 24px;
  font-weight: 400;
  color: ${palette.neutral[900]};
  text-align: center;
  line-height: 1.4;
`
